'use client';

import { useEffect } from 'react';

import { Error as ErrorPage } from '@/components/Error/Error';
import { logError } from '@/utils/log-error';

export default function Error({
  reset,
  error
}: {
  reset: () => void;
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    if (error.message === 'NEXT_NOT_FOUND') return;

    logError(error, {
      component: 'ErrorPage',
      digest: error.digest
    });
  }, [error]);

  return <ErrorPage reset={reset} />;
}
